import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=370c84a2&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=370c84a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370c84a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370c84a2')) {
      api.createRecord('370c84a2', component.options)
    } else {
      api.reload('370c84a2', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=370c84a2&scoped=true&", function () {
      api.rerender('370c84a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/checklist/Documents.vue"
export default component.exports